import React from 'react'

function OfferOne() {
    return (
        <>
            {/* special section start */}
            </>
    )     
}

export default OfferOne